
<div style="min-height: 100vh;" class="authBg container-fluid">
  <div class="card-body">
    <div class="row">
      <div class="col-md-5 p-0 text-right login-image">
        <img class="mt-0 mb-3" src='assets/img/reset-password.svg' />
      </div>
      <div class="col-md-7 text-center">

        <!-- ResetPassord form -->
        <div class="login-form" *ngIf="!wrongQueryParams">

          <div *ngIf="!success">
            <div class="text-center mb-3">
              <h1>{{ 'ChangePassword' | translate }}</h1>
            </div>

          <form [formGroup]="resetForm" class="login-container text-left" (ngSubmit)="reset()">

    

            <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
              <label>{{ 'Password' | translate }}</label>
              
              <div class="input-group change-pass-input">
                <input [type]="hide ?   'text' :'password' " class="form-control" type="password" [pattern]="passwordPattern" placeholder="{{ 'Password' | translate }}"
                  formControlName="password">
                <div class="input-group-append">
                  <span class="input-group-text"><mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon></span>
                </div>
              </div>
              <div *ngIf="isSubmitted && formControls.password.errors" class="required">
                <div *ngIf="formControls.password.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                <div *ngIf="formControls.password.errors.pattern"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RegisterPasswordValidationConstraint' | translate }}</div></div>
              </div>
            </div>

              <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && (formControls.confirmPassword.errors ||resetForm.hasError('notSame')) }">
                <label>{{ 'ConfirmPassword' | translate }}</label>
                <div class="input-group change-pass-input">
                <input [type]="hide1 ?   'text' :'password' " class="form-control" type="password" placeholder="{{ 'Enterthepasswordyoudefinedaboveagain' | translate }}"
                  formControlName="confirmPassword" [errorStateMatcher]="matcher">
                  <div class="input-group-append">
                    <span class="input-group-text"><mat-icon matSuffix (click)="hide1 = !hide1">{{hide1 ? 'visibility' : 'visibility_off'}}</mat-icon></span>
                  </div>
                </div>
                
                  <div *ngIf="isSubmitted && formControls.confirmPassword.errors" class="required">
                  <div *ngIf="formControls.confirmPassword.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                </div>
                <div *ngIf="isSubmitted && resetForm.hasError('notSame')" class="required">
                  <div *ngIf="resetForm.hasError('notSame')"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'PasswordDoNotMatch' | translate }}</div></div>
                </div>
                
              </div>



              <div class="text-center mb-3 mt-3">
                <button type="submit" class="btn login-btn">{{ 'Confirm' | translate }}</button>
              </div>

              <!-- <h1 *ngIf="isSubmitted&&success!=null&&success">{{ 'PasswordResetedPleaseLogin' | translate }}</h1>
              <h1  *ngIf="isSubmitted&&success!=null&&!success">{{ 'Somethingwentwrongpleasetryagain' | translate }}</h1> -->

            </form>
          </div>
        
          <!-- Success -->
          <div class="mt-3" *ngIf="isSubmitted&&success!=null&&success">                            
            <div class="login-form text-center sent-successfully">
              <mat-icon>check_circle_outline</mat-icon>
              <div class="text-center mb-3">
                <h1 class="text-blue">{{ 'YourPasswordChangedSuccessfully' | translate }}</h1>
              </div>
              <p class="text-center"><a class="back-to-login" (click)="showLogin()" >{{ 'BackToLogin' | translate }}</a></p>
            </div>
          </div> 

          <!-- Not Success -->
          <div class="d-flex post-back-msg mt-3" *ngIf="isSubmitted&&success!=null&&!success">
            <div class="d-flex justify-content-center align-items-center"><i class="fas fa-exclamation-circle mr-2 fa-2x"></i></div>
            <div class="d-flex justify-content-center align-items-center">{{"Sorry,Thislinkisnolongervalid" | translate}}.
            </div>
          </div>



        </div>

        <!-- <div *ngIf="wrongQueryParams">
          <h1>{{'SomethingWrongHappened' | translate}}</h1>
        </div> -->
        
        <div class="d-flex post-back-msg mt-3"  *ngIf="wrongQueryParams">
          <div class="d-flex justify-content-center align-items-center"><i class="fas fa-exclamation-circle mr-2 fa-2x"></i></div>
          <div class="d-flex justify-content-center align-items-center">{{"Sorry" | translate}}! {{"SomethingWrongHappened" | translate}}. </div>
        </div> 

        
        <!-- /ResetPassord form -->





      </div>
    </div>
  </div>
</div>


